import { render, staticRenderFns } from "./IdMono.vue?vue&type=template&id=d0b6ec4c"
import script from "./IdMono.vue?vue&type=script&lang=js"
export * from "./IdMono.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports